<template>
    <ComboboxLabel
        v-bind="forwarded"
        :class="cn('ds-combobox-label', props.class)"
    >
        <slot />
    </ComboboxLabel>
</template>

<script setup lang="ts">
import { cn } from '@/lib/utils';
import { reactiveOmit } from '@vueuse/core';
import type { ComboboxLabelProps } from 'reka-ui';
import { ComboboxLabel, useForwardProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';

const props = defineProps<ComboboxLabelProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = reactiveOmit(props, 'class');

const forwarded = useForwardProps(delegatedProps);
</script>
